import * as Sentry from '@sentry/react';
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router';
import { useEffect } from 'react';

export function initSentry() {
    const dsn = import.meta.env.VITE_SENTRY_DSN;
    const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:3000';
    const environment = import.meta.env.VITE_ENV_TYPE || 'development';
    const release = import.meta.env.VITE_SENTRY_RELEASE;

    if (!dsn) {
        console.warn('Sentry DSN not configured - error tracking disabled');
        return;
    }

    Sentry.init({
        dsn,
        environment,
        release,
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration({
                maskAllText: true,
                blockAllMedia: true,
                maskAllInputs: true,
            }),
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect: useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
        tracePropagationTargets: ['localhost', new RegExp(`^${apiUrl}`)],
        replaysSessionSampleRate: environment === 'production' ? 0.1 : 1.0,
        replaysOnErrorSampleRate: 1.0,
        enableLogs: true,
    });
}

// Re-export Sentry for easy access throughout the app
export { Sentry };
